import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopBemEstarNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Pesquisa aponta o que os brasileiros pensam dos serviços de saúde"
        links={[
          {
            to: '/saude-e-bem-estar-no-brasil/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="12" width="12" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/pesquisa-saude-e-bem-estar-no-brasil/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="12" width="12" />
                <span>Ver a pesquisa completa</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopBemEstarNavigation
